import { render, staticRenderFns } from "./SendLogMessageActionSetupView.vue?vue&type=template&id=9431d982&scoped=true&"
import script from "./SendLogMessageActionSetupView.vue?vue&type=script&lang=ts&"
export * from "./SendLogMessageActionSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9431d982",
  null
  
)

export default component.exports